var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "new-journal"
  }, [_c('div', {
    staticClass: "wrapper-header"
  }, [_c('HeaderNewCopy', {
    attrs: {
      "hasHeaderLine": _vm.hasHeaderLine,
      "mobHasMenu": false
    }
  })], 1), _c('Currencies'), _c('div', {
    staticClass: "investments-page"
  }, [_vm._l(_vm.currentPage, function (n) {
    return [_vm.onePagePosts ? [_c('InvestPostList', {
      key: 'posts_list_' + n,
      attrs: {
        "posts": _vm.onePagePosts[n - 1]
      }
    })] : _vm._e()];
  }), _c('div', {
    directives: [{
      name: "observe-visibility",
      rawName: "v-observe-visibility",
      value: _vm.handleScrolledToBottom,
      expression: "handleScrolledToBottom"
    }]
  }), _vm.showLoader ? _c('div', {
    staticClass: "loader-wrapper"
  }, [_c('img', {
    staticClass: "circle-loader",
    attrs: {
      "src": require("@/assets/img/circle-loader.svg")
    }
  })]) : _vm._e()], 2), _c('Footer')], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }